import './ccf-align-right-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAlignRightIconProps extends SvgIconProps {}
/**
 * Component used to display align Right Icon
 * @param props - CcfAlignRightIconProps
 * @example - <CcfAlignRightIcon />
 * @returns SVG of align right Icon
 */
export function CcfAlignRightIcon(props: CcfAlignRightIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="align-left_icon" data-name="Align Left" transform="translate(3.702 3.702)">
        <path d="M21,19H11a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0,4H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z" transform="translate(-2 -11)"/>
        </g>
    </SvgIcon>
  );
}

export default CcfAlignRightIcon;
